import round from 'lodash/round'

export function money(value: number, alwaysShowCents: boolean = false) {
    if(!alwaysShowCents && round(value, 2) === round(value,0)) {
        return `${value.toFixed(0)}`;
    }
    return `${value.toFixed(2)}`;
}

export const flatSurcharge = 0.35;
export const percentageSurcharge = 0.0128;

export function subtractSurchargeFromFee(total: number) {
    return ((total - flatSurcharge) / (1 + percentageSurcharge));
}